export type AppError = {
  message: string;
  code?: string;
};


export const ERROR_MESSAGES: Record<string, string> = {
  FOODICS_UNAUTHORIZED: "Foodics authorization expired. Please reconnect.",
  SYNC_FAILED: "Sync failed. Try again later.",
  OWNER_ALREADY_LINKED: "This integration already has an owner linked.",
  FILE_TOO_LARGE: "The file is too large. Please upload a smaller image (max 1MB).",
  REQUEST_TOO_LARGE: "The image file is too large for the server. Please use a smaller image.",
};

export function parseError(error: unknown): { message: string; code?: string } {
  const anyErr = error as any;

  if (anyErr.response?.data?.message) {
    return {
      message: anyErr.response.data.message,
      code: anyErr.response?.data?.code,
    };
  }

  // Handle HTTP status codes
  if (anyErr.status === 413) {
    return {
      message: ERROR_MESSAGES.REQUEST_TOO_LARGE,
      code: "REQUEST_TOO_LARGE",
    };
  }

  if (anyErr.response?.data?.code) {
    const code = anyErr.response.data.code;
    return {
      message: ERROR_MESSAGES[code] || "Something went wrong",
      code,
    };
  }

  if (anyErr.message) {
    return { message: anyErr.message };
  }

  return { message: String(error) || "Unknown error" };
}

